// 디자인 표준 (직원 관리 기준, 2026-08 통일) — 헤더/버튼/표는 std 토큰 사용
import {
  stdHeaderRow, stdPageTitle, stdPageSubtitle, STD_HEADER_TOP,
  stdBlackBtn, stdOutlineBtn, stdTh,
} from '../adminlayout/designStandard';

export const pageStyle = (isMobile) => ({
  // 데스크톱 여백은 AdminLayout(main) + STD_HEADER_TOP 가 담당 — 자체 padding 제거
  // 휴대폰은 공통 틀(AdminLayout main)이 좌우 16px 을 준다 — 겹치지 않게 0 (2026-09-28)
  padding: isMobile ? '10px 0' : 0,
  display: 'grid',
  gap: isMobile ? 10 : 16,
  minWidth: 0,
  boxSizing: 'border-box',
});

// 표준 헤더 행 — 아래 간격은 page grid gap 이 담당하므로 margin-bottom 0 으로 상쇄
export const headerStyle = (isMobile) => ({
  ...stdHeaderRow(isMobile),
  margin: isMobile ? '4px 0 0' : `${STD_HEADER_TOP}px 0 0`,
});

export const titleStyle = stdPageTitle;
export const subtitleStyle = stdPageSubtitle;

export const headerActionsStyle = (isMobile) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  flexWrap: 'wrap',
  justifyContent: isMobile ? 'flex-start' : 'flex-end',
  width: isMobile ? '100%' : 'auto',
});

const actionBase = (isMobile) => ({
  minHeight: 36,
  boxSizing: 'border-box',
  flex: isMobile ? '1 1 132px' : '0 0 auto',
});

export const primaryActionStyle = (isMobile) => ({
  ...stdBlackBtn,
  ...actionBase(isMobile),
});

export const secondaryActionStyle = (isMobile) => ({
  ...stdOutlineBtn,
  ...actionBase(isMobile),
});

export const filterPanelStyle = (isMobile) => ({
  background: 'var(--bg-card)',
  border: '1px solid var(--border)',
  borderRadius: 8,
  padding: isMobile ? 10 : 12,
  display: 'grid',
  gap: 8,
  minWidth: 0,
  boxSizing: 'border-box',
});

export const filterGridStyle = (isMobile) => ({
  display: 'grid',
  gridTemplateColumns: isMobile ? '1fr' : 'minmax(220px, 1.4fr) minmax(330px, 1.2fr) minmax(132px, .7fr) minmax(150px, .8fr) auto auto',
  gap: 8,
  alignItems: 'center',
  minWidth: 0,
});

const filterControlBase = {
  minHeight: 40,
  padding: '7px 10px',
  border: '1px solid var(--border)',
  borderRadius: 6,
  background: 'var(--bg)',
  color: 'var(--text)',
  boxSizing: 'border-box',
  fontSize: 13,
  lineHeight: 1.25,
  minWidth: 0,
};

export const searchInputStyle = () => ({ ...filterControlBase, width: '100%' });

export const dateRangeStyle = () => ({
  display: 'grid',
  gridTemplateColumns: 'auto minmax(0, 1fr) auto minmax(0, 1fr)',
  gap: 8,
  alignItems: 'center',
  minWidth: 0,
});

export const dateFilterInputStyle = () => ({ ...filterControlBase, width: '100%', minWidth: 0 });
export const filterSelectStyle = () => ({ ...filterControlBase, width: '100%' });

export const filterPrimaryButtonStyle = (isMobile) => ({
  ...primaryActionStyle(isMobile),
  width: isMobile ? '100%' : 'auto',
});

export const filterSecondaryButtonStyle = (isMobile) => ({
  ...secondaryActionStyle(isMobile),
  width: isMobile ? '100%' : 'auto',
});

export const listShellStyle = {
  background: 'var(--bg-card)',
  border: '1px solid var(--border)',
  borderRadius: 8,
  overflow: 'hidden',
  minWidth: 0,
};

export const paginationStyle = (isMobile) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: 8,
  fontSize: 12,
  flexWrap: 'wrap',
  paddingBottom: isMobile ? 4 : 0,
});

// 표 머리글 — 표준 검정 띠(stdTh), 15컬럼 밀도 유지 위해 padding 만 축소
export const th = { ...stdTh, padding: '8px 10px' };
export const td = { padding: '6px 10px', color: 'var(--text)' };

const noWrap = { whiteSpace: 'nowrap', overflowWrap: 'normal', wordBreak: 'normal' };

export const compactTd = { ...td, ...noWrap };
export const amountTd = { ...td, ...noWrap, textAlign: 'right' };
export const receiptTd = { ...compactTd, maxWidth: 150, overflow: 'hidden', textOverflow: 'ellipsis' };

export const pgBtn = {
  minHeight: 32,
  padding: '4px 10px',
  background: 'var(--bg-card)',
  color: 'var(--text)',
  border: '1px solid var(--border)',
  borderRadius: 4,
  cursor: 'pointer',
};
